import * as yup from "yup";

export const BDMSchema = yup.object().shape({
  first_name: yup.string().required().default("").label("First Name"),
  last_name: yup.string().required().default("").label("Last Name"),
  email: yup.string().email().required().default("").label("Email"),
  // terms_and_conditions: yup.string().label("Terms and Condition"),
});
